export default __webpack_public_path__ + "static/media/whatsapp.0dfd0e28.svg";